<template>
    <v-card :loader="loading">
        <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
            <v-text type="headline">
                {{ profile.activityType == 1 ? profile.orgName : profile.contactFio }}
            </v-text>
        </div>

        <v-separator />

        <div v-padding="3">
            <v-row>
                <v-col xs="12" sm="6">
                    <v-row v-margin.xs.top="3" v-margin.sm.top="0">
                        <v-col xs="12">
                            <v-text type="subheadling">Реквизиты</v-text>
                        </v-col>
                    </v-row>
                    <v-row v-for="item, index in org" :key="index">
                        <v-col xs="3" sm="6">
                            <v-text :danger="item[2]">
                                {{ item[0] }}
                            </v-text>
                        </v-col>
                        <v-col xs="9" sm="6">
                            <v-text>{{ item[1] }}</v-text>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-if="profile.activityType == 1" xs="12" sm="6">
                    <v-row v-margin.xs.top="3" v-margin.sm.top="0">
                        <v-col xs="12">
                            <v-text type="subheadling">Руководитель</v-text>
                        </v-col>
                    </v-row>
                    <v-row v-for="item, index in director" :key="index">
                        <v-col xs="3" sm="6">
                            <v-text :danger="item[2]">
                                {{ item[0] }}
                            </v-text>
                        </v-col>
                        <v-col xs="9" sm="6">
                            <v-text>{{ item[1] }}</v-text>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-else xs="12" sm="6">
                    <v-row v-margin.xs.top="3" v-margin.sm.top="0">
                        <v-col xs="12">
                            <v-text type="subheadling">Личные данные</v-text>
                        </v-col>
                    </v-row>
                    <v-row v-for="item, index in contact" :key="index">
                        <v-col xs="3" sm="6">
                            <v-text :danger="item[2]">
                                {{ item[0] }}
                            </v-text>
                        </v-col>
                        <v-col xs="9" sm="6">
                            <v-text>{{ item[1] }}</v-text>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="profile.activityType == 1" xs="12" sm="6">
                    <v-row v-margin.xs.top="3">
                        <v-col xs="12">
                            <v-text type="subheadling">Контактное лицо</v-text>
                        </v-col>
                    </v-row>
                    <v-row v-for="item, index in contact" :key="index">
                        <v-col xs="3" sm="6">
                            <v-text :danger="item[2]">
                                {{ item[0] }}
                            </v-text>
                        </v-col>
                        <v-col xs="9" sm="6">
                            <v-text>{{ item[1] }}</v-text>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col xs="12" sm="6">
                    <v-row v-margin.xs.top="3">
                        <v-col xs="12">
                            <v-text type="subheadling" :error="legalAddress[1]">
                                Юридический адрес
                            </v-text>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col xs="12">
                            <v-text>{{ legalAddress[0] }}</v-text>
                        </v-col>
                    </v-row>
                    <v-row v-margin.xs.top="3">
                        <v-col xs="12">
                            <v-text type="subheadling" :error="postalAddress[1]">
                                Почтовый адрес
                            </v-text>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col xs="12">
                            <v-text>{{ postalAddress[0] }}</v-text>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>

        <div v-padding="3" v-if="!profile.isIdentified">
            <v-row align-items="center">
                <v-col v-text-align.right>
                    <v-button flat primary @click="$router.push({ name: 'profileEdit', params: { edit: 'edit' } })">
                        редактировать
                    </v-button>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>
<script>
export default {
    name: 'profile-info',
    props: {
        errors: {
            type: Object,
            default() {
                return {};
            }
        },
        loading: {
            type: Boolean,
            default: false,
        },
        companyFullName: {
            type: String,
            default: '',
        },
        profile: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    methods: {
        hasError(field) {
            return this.errors && this.errors.hasOwnProperty(field);
        }
    },
    computed: {
        org() {
            const org = [
                ['ИНН', this.profile.inn, this.hasError('inn')],
                ['БИК', this.profile.bik, this.hasError('bik')],
                ['Р / счет', this.profile.paymentAccount, this.hasError('paymentAccount')],
                ['Банк', this.profile.bankName, this.hasError('bankName')],
                [
                    'К / счет',
                    this.profile.correspondentAccount,
                    this.hasError('correspondentAccount'),
                ],
            ]

            if (this._props.profile.activityType === 1) {
                org.push(
                    ['КПП', this.profile.kpp, this.hasError('kpp')],
                    ['ОГРН', this.profile.ogrn, this.hasError('ogrn')]
                )
            }

            if (this._props.profile.activityType === 2) {
                org.push(
                    ['ОГРНИП', this.profile.ogrn, this.hasError('ogrn')]
                )
            }

            return org;
        },
        director() {
            return [
                ['Фамилия', this.profile.lastName, this.hasError('lastName')],
                ['Имя', this.profile.firstName, this.hasError('firstName')],
                ['Отчество', this.profile.middleName, this.hasError('middleName')],
                ['Должность', this.profile.post, this.hasError('post')],
                [
                    'Действующий на основании',
                    this.profile.basisPost,
                    this.hasError('basisPost'),
                ]
            ]
        },
        contact() {
            return [
                ['ФИО', this.profile.contactFio, this.hasError('contactFio')],
                ['Телефон', this.profile.contactPhone, this.hasError('contactPhone')],
                ['Email', this.profile.contactEmail, this.hasError('contactEmail')]
            ]
        },
        legalAddress() {
            return [this.profile.addressUr, this.hasError('addressUr')];
        },
        postalAddress() {
            return [this.profile.addressPost, this.hasError('addressPost')];
        },
    }
}
</script>


// WEBPACK FOOTER //
// ProfileInfo.vue?91eb1452